import { Builder } from '@builder.io/react';

import { BlogSearch } from './blog-search';

Builder.registerComponent(BlogSearch, {
  name: 'BlogSearch',
  friendlyName: 'Blog Search',
  description: 'A search input for finding blog posts by title or content',
  image:
    'https://cdn.builder.io/api/v1/image/assets%2F3124f13d16c344a781aa2e5bdbc00183%2Fc79f51fe0e3c498f9d75078be387b316',
  inputs: [
    {
      name: 'placeholder',
      type: 'string',
      defaultValue: 'Search posts',
      helperText: 'Placeholder text shown in the search input',
    },
    {
      name: 'buttonText',
      type: 'string',
      defaultValue: 'Search',
      helperText: 'Text displayed on the search button',
    },
    {
      name: 'buttonColor',
      type: 'color',
      defaultValue: '#3b82f6',
      helperText: 'Background color of the search button',
    },
    {
      name: 'className',
      type: 'string',
      helperText: 'Additional CSS classes for custom styling',
      advanced: true,
    },
    {
      name: 'isConsumerNews',
      friendlyName: 'Consumer News',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  defaultStyles: {
    display: 'block',
    width: '100%',
  },
});
